/**
 * @generated SignedSource<<edd5b2b4958d8f67ff5af0feb70167df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type modalPreviewTemplateQuery$variables = {
  templateId: string;
};
export type modalPreviewTemplateQuery$data = {
  readonly node: {
    readonly __typename: "NoteTemplateNode";
    readonly id: string;
    readonly viewerCanEdit: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"PreviewNoteTemplate">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type modalPreviewTemplateQuery = {
  response: modalPreviewTemplateQuery$data;
  variables: modalPreviewTemplateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "templateId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanEdit",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "modalPreviewTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PreviewNoteTemplate"
              }
            ],
            "type": "NoteTemplateNode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "modalPreviewTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tags",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isViewer",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isNoteTemplateAuthor"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "Account",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ExternalAccount",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": "fullName",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "type": "TemplateUserAuthor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "darkModeLogo",
                        "storageKey": null
                      }
                    ],
                    "type": "TemplateCompanyAuthor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": "nameThatIsOptional",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "type": "TemplateIconAuthor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "starred",
                "storageKey": null
              }
            ],
            "type": "NoteTemplateNode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "57851873164d2ad580a2f998a7f3fccf",
    "id": null,
    "metadata": {},
    "name": "modalPreviewTemplateQuery",
    "operationKind": "query",
    "text": "query modalPreviewTemplateQuery(\n  $templateId: ID!\n) {\n  node(id: $templateId) {\n    __typename\n    ... on NoteTemplateNode {\n      id\n      viewerCanEdit\n      ...PreviewNoteTemplate\n    }\n    id\n  }\n}\n\nfragment MetadataNoteTemplate on NoteTemplateNode {\n  title\n  summary\n  tags\n  externalUrl\n  author {\n    __typename\n    ... on User {\n      isViewer\n    }\n    ...TemplateAuthor_Author\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...StarButtonNoteTemplate\n}\n\nfragment PreviewNoteTemplate on NoteTemplateNode {\n  id\n  ...MetadataNoteTemplate\n}\n\nfragment StarButtonNoteTemplate on NoteTemplateNode {\n  id\n  starred\n}\n\nfragment TemplateAuthor_Author on NoteTemplateAuthor {\n  __isNoteTemplateAuthor: __typename\n  __typename\n  ... on User {\n    id\n    fullName\n    image\n  }\n  ... on Account {\n    name\n    logo\n  }\n  ... on ExternalAccount {\n    name\n    logo\n  }\n  ... on TemplateUserAuthor {\n    image\n    fullName: name\n  }\n  ... on TemplateCompanyAuthor {\n    name\n    logo\n    darkModeLogo\n  }\n  ... on TemplateIconAuthor {\n    icon\n    color\n    nameThatIsOptional: name\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0d8995b1e15af38bcb5508ab2851c06";

export default node;
